/* eslint-disable @typescript-eslint/no-require-imports */

export const stageDetails = [
  {
    id: 1,
    title: "V0 - Whitepaper:",
    description:
      "We published our whitepaper, which outlined the core vision, architecture, and goals for the BLOK Capital protocol.",
  },
  {
    id: 2,
    title: "V1 - Public Launch & Multi-Chain Expansion:",
    description:
      "We launched the first version of our platform, allowing users to create and manage their 'Gardens' with a simple, gas-free experience. We also began our multi-chain expansion to Base, Arbitrum, and Optimism to offer more diverse options.",
  },
  {
    id: 3,
    title: "V2 - Automated Index Trackers:",
    description:
      "We will launch V2, which introduces automated index trackers for Gardens. This feature will enable users to create and follow passive, diversified investment strategies on the platform.",
  },
  {
    id: 4,
    title: "V3 - Introduction of 'Gardeners':",
    description:
      "We will release V3, introducing 'Gardeners' to the platform. These expert wealth managers will be able to create and manage portfolios on behalf of other community members, adding a layer of human expertise.",
  },
];


export const partners = [
  // {
  //   name: "QuestN",
  //   image: require("../images/QuestN.jpg"),
  //   website: "https://questn.com/",
  // },
  // {
  //   name: "Streamflow",
  //   image: require("../images/streamflow.jpg"),
  //   website: "https://streamflow.finance/",
  // },
  {
    name: "aragon",
    image: require("../images/aragon.png"),
    website: "https://www.aragon.org/",
  },
  // {
  //   name: "Coinfabrik",
  //   image: require("../images/Coinfabrik.png"),
  //   website: "https://www.coinfabrik.com/",
  // },
  {
    name: "ZeroDev",
    image: require("../images/zerodev.jpg"),
    website: "https://zerodev.app/",
  },
  {
    name: "pimlico",
    image: require("../images/pimlico-purple.jpg"),
    website: "https://docs.pimlico.io/",
  },
  {
    name: "Transak",
    image: require("../images/transak-logo.jpg"),
    website: "https://www.transak.com",
  },
  {
    name: "Web3Auth",
    image: require("../images/Web3Auth.jpg"),
    website: "https://www.web3auth.io",
  },
];

export const teamMembers = [
  {
    name1: "Sheetal",
    name: "0xSheetal",
    designation: "Founder",
    quote:
      "A visionary to invent an “original concept”.First startup Surfpin, Founder CEO and pioneer in mobile payments and Virtual Currency taken to over 50 countries with clients such as Disney.A Certified DAO, Ethereum, Blockchain and Metaverse Expert.",
    src: require("../images/Sheetal.jpg"),
    social: {
      linkedin: "https://www.linkedin.com/in/sheetalnehra/",
      farcaster: "https://warpcast.com/sheetal",
      twitter: "https://x.com/0xSheetal",
    },
  },
  {
    name: "Prof. Andy Wynn",
    designation: "Innovation Expert",
    quote:
      "Former CTO at Morgan Advanced Materials.Professor of Digital Transformation at IE Business School (Madrid, Spain). Author of best selling books Transforming Technology into Profit",
    src: require("../images/Andywynn.jpeg"),
    social: {
      linkedin: "https://www.linkedin.com/in/andy-wynn/",
    },
  },
  {
    name: "Mohammed Raihani",
    designation: "Marketing Expert",
    quote:
      "Former CEO of Petroleum Giant, Shell in Morocco.An in depth knowledge of the full marketing mix and a methodical approach to strategic thinking.An international multilingual leader with management expertise developed over 30 years of experience.",
    src: require("../images/riahni.jpg"),
    social: {
      linkedin: "https://www.linkedin.com/in/mohammed-raihani-159b3a22/",
    },
  },

  {
    name: "John Adebayo",
    designation: "Compliance Expert",
    quote:
      "A seasoned professional with compliance and data protection expertise such as GDPR. At BLOK Capital he is focused on risk, compliance, transparency and security.",
    src: require("../images/john.jpg"),
    social: {
      linkedin: "https://www.linkedin.com/in/johnadebayo/",
    },
  },
  {
    name1: "Chintan",
    name: "0xChintan",
    designation: "Interface Builder",
    quote:
      "Chintan is a blockchain Samurai warrior. He is focused on building everyday, focused and aligned on our Vision and making the protocol a reality.He works closely with the founders to ensure we deliver what we believe in.",
    src: require("../images/Chintan.jpg"),
    social: {
      linkedin: "https://www.linkedin.com/in/limbachiya-chintan/",
      farcaster: "https://warpcast.com/chintand30",
      twitter: "https://x.com/0xChintan",
    },
  },
  {
    name: "Elvis",
    designation: "Community Support",
    quote:
      "Elvis is a Crypto warrior. He is focused on building and working with our family, our community .. everyday, focused and aligned on our Vision and making the protocol better by understanding what the community needs.He works closely with the founders to ensure we deliver what we believe in.",
    src: require("../images/Elvis.jpg"),
    social: {
      farcaster: "https://warpcast.com/elvisnelson",
    },
  },
  {
    name1: "Etty",
    name: "0xEtty",
    designation: "Interface Builder",
    quote:
      "Etty is fully focused on the Interface to the Protocol. He possesses decades of experience in building interfaces and will ensure we build in a high quality fashion.He also works on our CI/CD pipeline to ensure releases flow to the community as securely and quickly as possible.",
    src: require("../images/Etty.png"),
    social: {
      linkedin: "https://www.linkedin.com/in/fullstackjsdeveloper/",
    },
  },
  {
    name: "Tammy",
    designation: "Smart Contract Security",
    src: require("../images/Tammy.jpeg"),
    social: {
      twitter: "https://x.com/0xtdey",
    },
  },
   {
    name: "Mustafa Mallebhari",
    designation: "UI UX Builder",
    src: require("../images/Mustafa.jpg"),
    social: {
      linkedin: "https://www.linkedin.com/in/mustafamallebhari/",
      twitter: "https://x.com/mallebhari_",
    },
  },
  {
    name: "Jayesh Yadav",
    designation: "Protocol Builder",
    src: require("../images/Jayesh_yadav.jpeg"),
    social: {
      linkedin: "https://www.linkedin.com/in/rohan-kapse/",
      twitter: "https://x.com/supitsrohan",
    },
  },
 
];

export const tokenData = [
  { "title": "IDO", "value": 20.0, "color": "#0083ff", "description": "Initial DEX offering", "subtitle": "Public sale" },
  { "title": "Product Development", "value": 15.0, "color": "#108bff", "description": "Technical development", "subtitle": "Core development" },
  { "title": "Team", "value": 20, "color": "#2092ff", "description": "Vested Over 3 Years", "subtitle": "Long-term team commitment" },
  { "title": "Treasury", "value": 12.5, "color": "#309aff", "description": "Platform development and maintenance", "subtitle": "Operational reserves" },
  { "title": "Marketing & PR", "value": 10.0, "color": "#40a2ff", "description": "Growth and awareness", "subtitle": "Market expansion" },
  { "title": "Liquidity", "value": 10.0, "color": "#50aaff", "description": "Market stability", "subtitle": "Trading liquidity" },
  { "title": "Seed", "value": 5.0, "color": "#60b2ff", "description": "Vested Over 3 Years", "subtitle": "Early stage investors" },
  { "title": "Influencers", "value": 3.0, "color": "#70b9ff", "description": "Marketing and promotion", "subtitle": "Strategic partnerships" },
  { "title": "Bug Bounty", "value": 3.0, "color": "#80c1ff", "description": "Security and improvements", "subtitle": "Platform security" },
  { "title": "Presale", "value": 3.0, "color": "#8fc9ff", "description": "Early supporters", "subtitle": "Private round" },
  { "title": "Advisors", "value": 3.0, "color": "#9fd0ff", "description": "Strategic guidance", "subtitle": "Expert consultation" },
  { "title": "Community", "value": 2.0, "color": "#afd8ff", "description": "Community development", "subtitle": "Building ecosystem" },
  { "title": "Air Drop", "value": 1.0, "color": "#bfe0ff", "description": "Community rewards and engagement", "subtitle": "Community incentives" }
];


export const faqs = [
  {
    question: "What is BLOK Capital?",
    answer:
      "BLOK Capital is a pioneering DeFi platform that bridges traditional finance with the crypto ecosystem, providing institutional-grade investment solutions while maintaining accessibility and transparency through blockchain technology.",
  },
  {
    question: "Is my money and data secure with BLOK Capital?",
    answer:
      "With a non-custodial wallet, you have sole control of your private keys, which in turn control your cryptocurrency and proves the funds are yours. No one apart from you can access your funds, even us! The BLOKC smart wallet accounts are easy, safe and smarter. Note: Always select guardians for your wallet, since if you lose your private keys - even we can't access it!",
  },
  {
    question: "Is BLOK Capital secure?",
    answer:
      "Yes, security is our top priority. We implement industry-leading security measures, smart contract audits, and follow best practices to ensure the safety of user funds and data.",
  },
  {
    question: "What are Stablecoins?",
    answer:
      "Stablecoins are digital assets pegged to a dollar. Meaning that no matter what - your stablecoins will always be redeemable to USD. We use USDC as our primary stablecoin - a trusted and regulated coin.",
  },
  {
    question: "How do I add / withdraw funds to and from my Wallet?",
    answer:
      "We have partnered up with the most secure and crypto payment processors so you can onramp your fiat into Crypto with ease. Our partners, such as Transak perform a quick KYC check and use your bank account or card to purchase ther stablecoin USDC to your account. You can also withdraw the assets that you have received / bought back to your bank account through similar channels.",
  },
  {
    question: "How do I get started with BLOK Capital?",
    answer:
      "Sign up on the web version with nothing but your email or a Farcaster account or web3 wallet ! Simply use your Social Login with Google and you're ready to explore the world of web3 and crypto.",
  },
  {
    question: "Is BLOKC available for Android, IOS and Web users?",
    answer:
      "No! You can always launch the web version. In the future we may have an iOs and Android App.",
  },
  {
    question: "How do I recover my BLOK Capital account if I lose access?",
    answer:
      "As BLOK Capital emphasizes self-custody, it's crucial to securely store your wallet’s recovery phrases. If you lose access, recovery depends on these credentials. BLOK Capital may not have access to your private information, so ensure you follow best practices for securing and backing up your wallet information.",
  },
  {
    question: "What security measures does BLOK Capital have in place?",
    answer:
      "Self-Custody: Investors maintain control over their assets, reducing the risk associated with third-party custody.\nSmart Contracts: Utilizes audited and secure smart contracts to manage transactions and agreements.\nTransparency: All operations are conducted on the blockchain, providing an immutable and transparent record.",
  },
  {
    question: "Is there a minimum deposit required to use BLOK Capital?",
    answer:
      "There is no minimum deposit requirement while using BLOK Capital, users can deposit as little as 10USDC to their gardens.",
  },
  {
    question: "Are there any geographic restrictions for using BLOK Capital?",
    answer:
      "There are no geographic restrictions for using BLOK Capital. We are fully decentralized and welcome our users beyond any geographic boundaries.",
  },
];


export const BLOKCaudits = [
  {
    name: "BLOKC v1.0",
    auditor: "CredShields",
    auditorlink: "https://credshields.com/",
    link: "https://github.com/BLOKCapital/audits/blob/main/audits/Blok%20Capital%20Final%20Report.pdf",
    date: "December 1st, 2024",
    status: "Passed",
    findings: {
      critical: 0,
      high: 2,
      major: 12,
      minor: 5,
      informational: 2,
    },
  },
];

export const zerodevAudits = [
  {
    name: "Zerodev Smart Wallet Audit",
    auditor: "Multiple Auditors",
    description:
      "The BLOK Capital protocol uses a Zerodev Smart Wallet Account Kernel v3 to ensure your self-custody wallet is secure.",
    reports: [
      {
        name: "Chainlight v3.0",
        link: "https://github.com/zerodevapp/kernel/blob/main/audits/chainlight_v3_0.pdf",
        date: "5 Apr 2024",
        auditor: "Chainlight",
        findings: {
          critical: "-",
          high: "-",
          midium: "-",
          low: "-",
          tips: "-",
        },
      },
      {
        name: "Kalos v3 Plugins",
        link: "https://github.com/zerodevapp/kernel/blob/main/audits/kalos_v3_plugins.pdf",
        date: "12 Apr 2024",
        auditor: "Kalos",
        auditorlink: "https://kalos.xyz/",
        findings: {
          critical: "-",
          high: "-",
          midium: "-",
          low: "-",
          tips: "-",
        },
      },
      {
        name: "Kalos WebAuthn v1",
        link: "https://github.com/zerodevapp/kernel/blob/main/audits/kalos_webauthn_v1.pdf",
        date: "22 Feb 2024",
        auditor: "Kalos",
        auditorlink: "https://kalos.xyz/",
        findings: {
          critical: "-",
          high: "-",
          midium: "-",
          low: 2,
          tips: "-",
        },
      },
      {
        name: "Kalos Recovery v2",
        link: "https://github.com/zerodevapp/kernel/blob/main/audits/kalos_recovery_v2.pdf",
        date: "6 Feb 2024",
        auditor: "Kalos",
        auditorlink: "https://kalos.xyz/",
        findings: {
          critical: 2,
          high: "-",
          midium: "-",
          low: 1,
          tips: "-",
        },
      },
      {
        name: "Kalos Recovery v1",
        link: "https://github.com/zerodevapp/kernel/blob/main/audits/kalos_recovery_v1.pdf",
        date: "12 Dec 2023",
        auditor: "Kalos",
        auditorlink: "https://kalos.xyz/",
        findings: {
          critical: 1,
          high: "-",
          midium: "-",
          low: "-",
          tips: "-",
        },
      },
      {
        name: "Kalos v2.2 Lite",
        link: "https://github.com/zerodevapp/kernel/blob/main/audits/kalos_v2_2_lite.pdf",
        date: "20 Sep 2023",
        auditor: "Kalos",
        auditorlink: "https://kalos.xyz/",
        findings: {
          critical: 1,
          high: "-",
          midium: "-",
          low: "-",
          tips: "-",
        },
      },
      {
        name: "Kalos v2.2",
        link: "https://github.com/zerodevapp/kernel/blob/main/audits/kalos_v2_2.pdf",
        date: "9 Aug 2023",
        auditor: "Kalos",
        auditorlink: "https://kalos.xyz/",
        findings: {
          critical: 1,
          high: 2,
          midium: 4,
          low: "-",
          tips: 1,
        },
      },
      {
        name: "Kalos v2.1",
        link: "https://github.com/zerodevapp/kernel/blob/main/audits/kalos_v2_1.pdf",
        date: "9 Aug 2023",
        auditor: "Kalos",
        auditorlink: "https://kalos.xyz/",
        findings: {
          critical: 1,
          high: 2,
          midium: 4,
          low: "-",
          tips: 1,
        },
      },
      {
        name: "Kalos v1",
        link: "https://github.com/zerodevapp/kernel/blob/main/audits/kalos_v1.pdf",
        date: "13 Jul 2023",
        auditor: "Kalos",
        auditorlink: "https://kalos.xyz/",
        findings: {
          critical: "-",
          high: "-",
          midium: "-",
          low: "-",
          tips: 5,
        },
      },
    ],
  },
];